import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs'
import { EcitationUserService } from 'src/services/ecitation-user.service';
import { AuthService } from 'src/services/auth.service';

type HeaderMenuId = 'reports' | 'system' | 'workflow' | 'access';

@Component({
    selector: 'app-ecitation-header',
    templateUrl: './ecitation-header.component.html',
    styleUrls: ['./ecitation-header.component.css'],
    standalone: false
})
export class EcitationHeaderComponent implements OnInit, OnDestroy {
  userEmail?: string = ''
  username?: string = '';
  userType?: any;
  activeMenu: HeaderMenuId | null = null;
  private subcription: Subscription
  constructor(private route: Router
    , private ecitationUserService: EcitationUserService, public authType: AuthService) {
    this.subcription = this.ecitationUserService.reloadComponent1$.subscribe(() => {
      this.getMenuType();
      this.authType.menuType = sessionStorage.getItem('menuType')
      this.goToAdminPage(this.authType.menuType);
    })
  }

  ngOnDestroy() {
    this.subcription.unsubscribe();
    this.userType;
  }

  openMenu(menu: HeaderMenuId) {
    this.activeMenu = menu;
  }

  closeMenu(menu: HeaderMenuId) {
    if (this.activeMenu === menu) {
      this.activeMenu = null;
    }
  }

  closeAllMenus() {
    this.activeMenu = null;
  }

  isMenuOpen(menu: HeaderMenuId) {
    return this.activeMenu === menu;
  }

  onDropdownOpenChange(isOpen: boolean, menu: HeaderMenuId) {
    if (isOpen) {
      this.openMenu(menu);
    } else {
      this.closeMenu(menu);
    }
  }

  onMenuFocusOut(event: FocusEvent, menu: HeaderMenuId) {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const nextTarget = event.relatedTarget as Node | null;

    if (currentTarget && nextTarget && currentTarget.contains(nextTarget)) {
      return;
    }

    this.closeMenu(menu);
  }

  onMenuKeydown(event: KeyboardEvent, menu: HeaderMenuId) {
    if (event.key === 'Escape') {
      this.closeMenu(menu);
      event.stopPropagation();
      return;
    }

    if (event.key === 'ArrowDown' && !this.isMenuOpen(menu)) {
      this.openMenu(menu);
    }
  }

  getMenuType() {
    this.authType.menuType = sessionStorage.getItem('menuType')
    if (this.authType.menuType === 'ROLE_ADMIN') {
      this.authType.menuType = "ROLE_ADMIN"
      this.authType.menuView = true
      this.authType.isLoggedInVar = true;
      this.authType.isNonAdminActive = sessionStorage.getItem('isNonAdminActive') == 'true';
    } else if (this.authType.menuType === 'ROLE_NON_ADMIN') {
      this.authType.menuType = "ROLE_NON_ADMIN"
      this.authType.isLoggedInVar = true;
      this.authType.menuView = false;
    }
  }

  ngOnInit() {
    this.userType = this.authType.getUserType();
    this.getMenuType();
  }

  gotoMuniStatus(){
    if(this.route.url === '/secure/ecitationMuniStatus'){
      this.ecitationUserService.reloadComponent1()
    }else{
      this.route.navigate(['/secure/ecitationMuniStatus']);
    }
  }

  goToEcitation(){
    if(this.route.url === '/secure/ecitationSearch'){
      this.ecitationUserService.reloadComponent1()
      this.route.navigate(['/secure/ecitationSearch']);
      this.authType.isNonAdminActive = true;
    }else{
      this.route.navigate(['/secure/ecitationSearch']);
    }
  }
  goToPublicSearch(){
    if(this.route.url === '/'){
      this.ecitationUserService.reloadComponent1()
      this.route.navigate(['/']);
    }else{
      this.route.navigate(['/']);
    }
  }
  
  goToErrorDocSearch(){
    if(this.route.url === '/secure/errorDocSearch'){
      this.ecitationUserService.reloadComponent1()
      this.route.navigate(['/secure/errorDocSearch']);
      this.authType.isNonAdminActive = true;
    }else{
      this.route.navigate(['/secure/errorDocSearch']);
    }
  }


  goToLogin() {
    this.closeAllMenus();
    this.route.navigate(['secure/login'])
  }

  logout() {
    this.closeAllMenus();
    if (sessionStorage.getItem('loggedInUser')) {
      sessionStorage.removeItem('loggedInUser')
      sessionStorage.removeItem('menuType')
      sessionStorage.removeItem('accessToken')
      sessionStorage.removeItem('currentUser')
      sessionStorage.clear()
      this.authType.menuType = 'public'
      this.authType.isLoggedInVar = false;
      this.route.navigate(['secure/login'])
    }
  }

  goToEcitationSearch() {
    this.closeAllMenus();
    this.authType.menuType = 'ROLE_NON_ADMIN'
    this.route.navigate(['secure/ecitationSearch'])
  }

  goToAdminPage(item: string) {
    this.closeAllMenus();
    this.authType.menuType = item;
    if (item === 'ROLE_ADMIN') {
      this.authType.isNonAdminActive = false;
      sessionStorage.setItem('isNonAdminActive', 'false')
    this.route.navigate(['secure/ecitationMuniStatus'])
    } else if (item === 'ROLE_NON_ADMIN') {
      this.authType.isNonAdminActive = true;
      sessionStorage.setItem('isNonAdminActive', 'true')
      this.route.navigate(['secure/ecitationSearch']);
      document.getElementById('activeEle1')?.focus();
      console.log( document.getElementById('activeEle1'))
    } 
   
  }
  getCurrentTime() {
    let cTime = new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'CST' })
    return `${cTime} CST`
  }
  hoverEvent(event: any) {
    event.open();
  }
  hoverEventOut(event: any) {
    event.close();
  }
}

